<ng-container [formGroup]="constructFormSection">
  <div class="mt-3">
    @if (showConfirmRemovePartDialog) {
      <app-delete-confirmation
        [message]="'Are you sure you want to remove this part?'"
        (confirm)="removePart(this.removePartIter, this.removePartsControl)"
        (cancel)="showConfirmRemovePartDialog = false">
      </app-delete-confirmation>
    }
    <div [formGroup]="general">
      @for (partsForm of parts.controls; track partsForm; let i = $index) {
        <div formArrayName="parts" class="flex justify-center mt-[40px]">
          @if (!partsForm.get('expanded')?.value) {
            <div class="flex border border-[#74808B] rounded-[8px] w-full mx-[21px] px-[14px] py-[8px] items-center hover:bg-gray-200">
              <div class="flex justify-between items-center w-full">
                <button aria-label="Expand" (click)="partsForm.get('expanded')?.setValue(true)" class="flex items-center flex-grow">
                  <fa-icon [icon]="faChevronDown" />
                  <div class="ml-[22px] py-[5px]">
                    {{partsForm.get('part_name')?.value}}
                  </div>
                </button>
                <!-- TODO if parts are removed till only one remains and entrypoint is false it needs to be set to true -->
                <button aria-label="Remove Part" (click)="confirmRemovePart(i, parts.controls)" class="hover:bg-gray-300 rounded-full w-[24px] h-[24px]">
                  <fa-icon [icon]="faXmark" />
                </button>
              </div>
            </div>
          }
          @if (partsForm.get('expanded')?.value) {
            <div class="w-full mx-[21px]">
              <tab-stepper-container>
                <cdk-step label="General">
                  <div [formGroupName]="i" class="flex-col border border-[#74808B] rounded-b-[8px] rounded-r-[8px] items-center text-[#424D57]">
                    <div class="flex justify-between hover:bg-gray-200 px-[14px] py-[8px] rounded-tr-[8px]">
                      <button aria-label="Collapse" (click)="partsForm.get('expanded')?.setValue(false)" class="flex items-center flex-grow">
                        <fa-icon [icon]="faChevronUp" />
                        <div class="ml-[22px] py-[5px]">
                          {{partsForm.get('part_name')?.value}}
                        </div>
                      </button>
                      <button aria-label="Remove Part" (click)="confirmRemovePart(i, parts.controls)" class="hover:bg-gray-300 rounded-full w-[24px] h-[24px]">
                        <fa-icon [icon]="faXmark" />
                      </button>
                    </div>
                    <div class="px-[14px] py-[8px] flex flex-col gap-6">
                      <div class="flex flex-col gap-1">
                        <p class="font-medium">
                          Part Name
                        </p>
                        <div class="text-[#8B96A2] text-sm">
                          Add a title of this part
                        </div>
                        <input formControlName="part_name" class="w-full input" />
                      </div>
                      <div class="flex flex-col gap-1">
                        <p class="font-medium">
                          Instructions
                        </p>
                        <div class="text-[#8B96A2] text-sm">
                          Add additional instructions that the student can view before starting "{{partsForm.get('part_name')?.value}}"
                        </div>
                        <quill-editor [styles]="{height: '200px', 'max-width': '100%'}" [modules]="modules" format="html" formControlName="part_instructions"></quill-editor>
                      </div>
                      <div class="flex flex-col gap-1">
                        <p class="font-medium">
                          Time Limit
                        </p>
                        <div class="text-[#8B96A2] text-sm">
                          Set a time duration for “{{partsForm.get('part_name')?.value}}”
                        </div>
                        <div class="flex items-center">
                          @if (partsForm.get('part_duration_minutes')?.value != null) {
                            <button (click)="noTimeClick(partsForm)" class="bg-[#F6F7F8] rounded-[4px] text-[14px] px-[10px] py-[8px]">
                              None
                            </button>
                          }
                          @if (partsForm.get('part_duration_minutes')?.value == null) {
                            <button (click)="noTimeClick(partsForm)" class="text-white bg-[#74808B] rounded-[4px] text-[14px] px-[10px] py-[8px]">
                              None
                            </button>
                          }
                          <div class="border border-[#D9D9D9] rounded h-[34px] w-[1px] mx-[8px]"></div>
                          @if (partsForm.get('part_duration_minutes')?.value != null) {
                            <input min="1" formControlName="part_duration_minutes" type="number" placeholder="Enter Value" class="disabled:bg-[#CBD1D7] disabled:text-[#8B96A2] bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] noOutlineInput" />
                          }
                          @if (partsForm.get('part_duration_minutes')?.value == null) {
                            <input [disabled]="true" type="number" placeholder="Enter Value" class="disabled:bg-[#CBD1D7] disabled:text-[#8B96A2] bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] noOutlineInput" />
                          }
                          <div class="text-[#34393E] text-[14px] ml-[8px]">
                            Minutes
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col gap-1">
                        <div>
                          <mat-checkbox [disabled]="parts.length === 1" (click)="entrypointClick(parts.controls, partsForm.get('entrypoint')?.value, i)" [checked]="partsForm.get('entrypoint')?.value">
                            <mat-label>Is entry point?</mat-label>
                          </mat-checkbox>
                        </div>
                        <div class="text-[#8B96A2] text-sm">
                          <b>Entry Point:</b> denote if this part is the first part the student will take. Only one part can be the entry point for the exam.
                        </div>
                      </div>
                    </div>
                  </div>
                </cdk-step>
                <cdk-step label="Content">
                  <div [formGroupName]="i" class="flex-col border border-[#74808B] rounded-[8px] items-center text-[#424D57] min-h-[600px]">
                    <button aria-label="Collapse" (click)="partsForm.get('expanded')?.setValue(false)" class="flex items-center flex-grow w-full px-[14px] py-[8px] rounded-t-[8px] hover:bg-gray-200">
                      <fa-icon [icon]="faChevronUp" />
                      <div class="ml-[22px] py-[5px]">
                        {{partsForm.get('part_name')?.value}}
                      </div>
                    </button>
                    <div class="flex w-full justify-between p-[14px]">
                      <div>
                        Select your content here. Please make sure that you select at least one learning objective and that you have problem templates to use.
                      </div>
                      <div>
                        Problem template count: {{allProblemTemplates.length}}
                      </div>
                    </div>
                    <div class="px-[14px] py-[8px]">
                      <p class="mb-[6px] mt-6 font-medium">
                        Choose the subject(s):
                      </p>
                      <dropdown-search (APIResponseFunction)="getSubjectChildren(selectedSubjectID)" [(selectedSubjectID)]="selectedSubjectID" [items]="allSubjects" [addedList]="allSubjectsAdded" placeholder="Enter subject name or select from the drop-down" />
                      @for (subject of allSubjectsAdded; track subject; let i = $index) {
                        <span>
                          <button aria-label="Remove subject" (click)="removeAddedSubject(i)" class="inline-flex flex-row rounded-[50px] bg-[#2663FF14] px-[10px] py-[8px] text-[14px] items-center m-1 text-[#424D57]">
                            <fa-icon [icon]="faXmark" class="mr-[10px]"/>
                            {{subject.name}}
                          </button>
                        </span>
                      }
                      @if (allCCLs.length !== 0 || allAddedCCLs.length > 0) {
                        <div>
                          <p class="font-medium mb-[6px] mt-[26px]">
                            Choose your CCLs(s):
                          </p>
                          <dropdown-search (APIResponseFunction)="getCCLChildren(selectedCCLID)" [(selectedCCLID)]="selectedCCLID" [items]="allCCLs" [addedList]="allAddedCCLs" placeholder="Enter CCL name or select from the drop-down" />
                          @for (lo of allAddedCCLs; track lo; let i = $index) {
                            <span>
                              <button (click)="removeAddedCCL(i)" class="inline-flex flex-row rounded-[50px] bg-[#2663FF14] px-[10px] py-[8px] text-[14px] items-center m-1 text-[#424D57]">
                                <fa-icon [icon]="faXmark" class="mr-[10px]"/>
                                {{lo.name}}
                              </button>
                            </span>
                          }
                        </div>
                      }
                      @if (allSubCCLs.length !== 0 || addedSubCCLs.length > 0) {
                        <div>
                          <p class="font-medium mb-[6px] mt-[26px]">
                            Choose your sub CCLs(s):
                          </p>
                          <dropdown-search (APIResponseFunction)="getCCLChildren(selectedCCLID)" [(selectedCCLID)]="selectedCCLID" [items]="allSubCCLs" [addedList]="addedSubCCLs" placeholder="Enter sub CCL name or select from the drop-down" />
                          @for (lo of addedSubCCLs; track lo; let i = $index) {
                            <span>
                              <button (click)="removeAddedSubCCL(i)" class="inline-flex flex-row rounded-[50px] bg-[#2663FF14] px-[10px] py-[8px] text-[14px] items-center m-1 text-[#424D57]">
                                <fa-icon [icon]="faXmark" class="mr-[10px]"/>
                                {{lo.name}}
                              </button>
                            </span>
                          }
                        </div>
                      }
                      @if (allLearningObjective.length !== 0 || addedLearningObjective.length > 0) {
                        <div>
                          <p class="font-medium mb-[6px] mt-[26px]">
                            Choose your learning objective(s):
                          </p>
                          <dropdown-search (APIResponseFunction)="getProblemTemplates()" [items]="allLearningObjective" [addedList]="addedLearningObjective" placeholder="Enter learning objective name or select from the drop-down" />
                          @for (lo of addedLearningObjective; track lo; let i = $index) {
                            <span>
                              <button (click)="removeAddedLO(i)" class="inline-flex flex-row rounded-[50px] bg-[#2663FF14] px-[10px] py-[8px] text-[14px] items-center m-1 text-[#424D57]">
                                <fa-icon [icon]="faXmark" class="mr-[10px]"/>
                                {{lo.name}}
                              </button>
                            </span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </cdk-step>
                <cdk-step label="Questions">
                  <!-- TODO pass down necessary form information like index and name -->
                  <assessment-questions [(allProblemTemplates)]="allProblemTemplates" [(allSubjectsAdded)]="allSubjectsAdded" [(addedLearningObjective)]="addedLearningObjective" [subject_ids]="selectedSubjects" [ccl_ids]="selectedCCLs" [part_index]="i" formGroupName="parts"></assessment-questions>
                </cdk-step>
              </tab-stepper-container>
            </div>
          }
        </div>
      }
    </div>
    <div class="flex justify-center mt-5">
      <outline-button text="Add Exam Part" [faIcon]="faAdd" (click)="addParts()" />
    </div>
  </div>

</ng-container>
